module.exports = __webpack_public_path__ + "img/logo-full-dark.6da7e7d.svg";